__webpack_require__.p = "/LeagueRegistration/";